
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RoomFormData } from "@/types/hotel";

interface RoomDialogDateRangeProps {
  formData: RoomFormData;
  setFormData: React.Dispatch<React.SetStateAction<RoomFormData>>;
}

export const RoomDialogDateRange = ({ formData, setFormData }: RoomDialogDateRangeProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="from_date">من تاريخ</Label>
        <Input
          id="from_date"
          type="date"
          value={formData.from_date}
          onChange={(e) => setFormData(prev => ({ ...prev, from_date: e.target.value }))}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="to_date">إلى تاريخ</Label>
        <Input
          id="to_date"
          type="date"
          value={formData.to_date}
          onChange={(e) => setFormData(prev => ({ ...prev, to_date: e.target.value }))}
        />
      </div>
    </div>
  );
}
